import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  prepareCatalogApiFieldsConfig,
  prepareCatalogApiFieldsValue
} from '../../adapters/catalog-api-eval/catalog-api-eval.adapter';
import { BookWidgetStoreKey } from '../../constants/common.constants';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';

const bookWidgetStoreFeatureSelector =
  createFeatureSelector<BookWidgetStore>(BookWidgetStoreKey);

const getCatalogApiState = createSelector(
  bookWidgetStoreFeatureSelector,
  (state) => state.catalogApi
);

export const shouldTriggerCatalogApi = createSelector(
  getCatalogApiState,
  ({ isReady }) => !isReady
);

export const isCatalogApiStateReady = createSelector(
  getCatalogApiState,
  ({ isReady, isError }) => isReady || isError
);

export const getCatalogApiFieldsValue = createSelector(
  getCatalogApiState,
  ({ catalogApiData }) => prepareCatalogApiFieldsValue(catalogApiData)
);

export const getCatalogApiFieldsConfig = createSelector(
  getCatalogApiState,
  ({ catalogApiData }) => prepareCatalogApiFieldsConfig(catalogApiData)
);
